import SectionLayout from '@/layouts/section-layout/section.layout';
import { DashboardFilters, Insights } from '@/services/dashboard-service/dashboard.service.types';
import InsightsCardsWrapper from './insights-cards-wrapper/insights-cards-wrapper';
import styles from './insights.module.scss';
import { message } from 'antd';
import { useTrendingTopicsExport } from '@/hooks/use-trending-topics-export/use-trending-topics-export';

interface InsightsProps {
  filters: DashboardFilters;
  insightsData?: Insights;
  isPending: boolean;
}

export default function InsightsSection({ filters, insightsData, isPending }: InsightsProps) {
  const [messageApi, contextHolder] = message.useMessage();
  const { downloadTrendingTopics, isPending: isDownloadingPending } = useTrendingTopicsExport({
    time_range: filters.time_range,
    start_time: filters.start_time,
    end_time: filters.end_time,
  });

  const handleDownloadTxt = () => {
    downloadTrendingTopics().then(() => {
      messageApi.open({
        type: 'success',
        content: 'File downloaded successfully',
      });
    });
  };

  return (
    <SectionLayout sectionTitle="Insights" className={styles.layout}>
      {contextHolder}
      <InsightsCardsWrapper
        isExporting={isDownloadingPending}
        onExport={handleDownloadTxt}
        isLoading={isPending}
        insightsData={insightsData}
        insight={insightsData?.trending_topics || {}}
      />
    </SectionLayout>
  );
}
